export const parseSerialNumbers = (serialNumberText: string): string[] => {
  if (!serialNumberText.length) return []
  const potentialSerialNumbers = serialNumberText.split(';')
  const lastPotentialSerialNumber = potentialSerialNumbers[potentialSerialNumbers.length - 1]
  if (lastPotentialSerialNumber === '') {
    potentialSerialNumbers.pop()
  }
  return potentialSerialNumbers
}

export const SERIAL_NUMBER_PATTERN = /^[\dA-Z]{4}[\d]{7}$/
export const BULK_SERIAL_NUMBER_PATTERN = /([\dA-Z]{4}[\d]{7})(?=;)/g
export const isValidSerialNumberFormat = (serialNumber: string): boolean => SERIAL_NUMBER_PATTERN.test(serialNumber)
export const isValidBulkSerialNumberFormat = (serialNumbers: string): boolean =>
  BULK_SERIAL_NUMBER_PATTERN.test(serialNumbers)
